import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import { abbrNumberFilter, percentageFilter } from "app/filters/ngFilters";

import { Column } from "../../common/legend/Column";
import { DomainColumn } from "../../common/legend/DomainColumn";
import type { ILegendColumnConfig } from "../../common/legend/MetricLegend";
import { MetricLegend } from "../../common/legend/MetricLegend";
import type { IChartDataItem } from "../../common/widget/donut-metric/types";

const abbrNumber = abbrNumberFilter();

const getMaxNonOthers = (items: IChartDataItem[], key: "y" | "value") => {
    const nonOthers = items.filter((item) => !item.isOthers);
    return nonOthers.length > 0 ? Math.max(...nonOthers.map((item) => item[key])) : 0;
};

export const ContentActivityLegend = () => {
    const { translate } = useTranslate();

    const columns = useMemo(
        (): ILegendColumnConfig[] => [
            {
                header: translate("activation.alerts.metrics.legend.domain"),
                textAlign: "left",
                render: (item) => (
                    <DomainColumn
                        key="domain"
                        item={item}
                    />
                ),
            },
            {
                header: translate("activation.alerts.metrics.legend.share"),
                render: (item, allItems) => {
                    const maxShare = getMaxNonOthers(allItems, "y");
                    return (
                        <Column
                            key="share"
                            fontVariant={!item.isOthers && item.y === maxShare ? "subtitle2" : "body2"}
                            data-automation="content-activity-legend-share"
                        >
                            {`${percentageFilter()(item.y, 0)}%`}
                        </Column>
                    );
                },
            },
            {
                header: translate("activation.alerts.metrics.legend.total-posts"),
                render: (item, allItems) => {
                    const maxValue = getMaxNonOthers(allItems, "value");
                    return (
                        <Column
                            key="value"
                            fontVariant={!item.isOthers && item.value === maxValue ? "subtitle2" : "body2"}
                            data-automation="content-activity-legend-total"
                        >
                            {abbrNumber(item.value)}
                        </Column>
                    );
                },
            },
        ],
        [translate],
    );

    return (
        <MetricLegend
            columns={columns}
            dataAutomation="website-content-metrics-legend"
        />
    );
};
